@if (isLoading) {
  <div id="spinner">
    <mat-progress-spinner
      class="mat-spinner-color"
      mode="indeterminate">
    </mat-progress-spinner>
  </div>
}

<div class="dialog-header">
  <h2 mat-dialog-title>List of Admins</h2>

  <button
    class="mat-close-btn"
    mat-button
    mat-dialog-close
    aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="table-container mat-elevation-z8">
    <custom-table
      [tableData]="dataSource.data"
      [tableColumns]="tableColumns"
      [tableActions]="tableActions"
      [isLoading]="isLoading"
      isFilterPresent="true"
      [filterAttributes]="filterAttributes"
      hideTableTitle="true"
      [tableTitle]="'Admins'"
      [pageType]="tableColumnPageType"
      (toogleEmitter)="onToggleChange($event)"
      [handleToggleInParent]="true"
      (tableActionEmitter)="tableActionEmitter($event)"
      (rowAction)="rowAction($event)"
      [showBreadcrumb]="false">
    </custom-table>
  </div>
</mat-dialog-content>

<app-confirm-dialog
  [title]="'Delete Admin'"
  [message]="warningMessage"
  [confirmButtonText]="'Delete'"
  [cancelButtonText]="'Cancel'"
  (confirm)="onConfirmDelete()"
  (cancel)="onCancelDelete()">
</app-confirm-dialog>